import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const FarmerBalanceList = (props) => {
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getDataList } = useHttp();

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/farmerOpeningBalances/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.cropName.toLowerCase().includes(filetrtext) ||
        item.varietyName.toLowerCase().includes(filetrtext) ||
        item.unitAbbreviation.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  console.log("loginUserId", loginUserId);
  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const { sendRequest: getDetailView } = useHttp();

  const openModal = (data) => {
    console.log(data);

    const farmerBalancesId = (data && data.farmerBalancesId) || 0;

    getDetailView(
      {
        url: `/api/farmerOpeningBalances/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerBalancesId=${farmerBalancesId}`,
      },
      (res) => {
        console.log("Detail View", res);

        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const [selecteditem, setSelecteditem] = useState(null);

  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelecteditem(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };
  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));

    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selecteditem && selecteditem.farmerBalancesId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    console.log("approve balance data", data);

    updateApprovalStatus(
      {
        url: "/api/approveFarmerOpeningBalances/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <AntModal
        title="Procurement Reciept Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Farmer Balance{" "}
            </label>{" "}
          </div>
          <div className="col-4"> </div>
          <div className="col-2">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                props.addForm(true);
                props.sId(serviceId);
                props.update(false);
              }}
            >
              Upload
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row ">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Doc No</th>
                            <th>Employee Name</th>
                            <th>Approved By</th>
                            <th>Approval</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.farmerBalancesDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.approvedByName}</td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.nextlevel == 1
                                        ? x.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : x.approved == 0 &&
                                          x.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Farmer Balance Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Date : {selectedData.farmerBalancesDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Employee Name: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                Approved By Name : {selectedData.approvedByName}
              </p>
            </div>

            <h5 className="card-title">Balance Details</h5>
            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Farmer Name</th>
                  <th>Farmer No</th>
                  <th>Amount Balance</th>
                  <th>Type Of Balance</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productData &&
                  selectedData.productData.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.farmerName}</td>
                        <td>{itm.farmerNo}</td>

                        <td>{itm.amountBalance}</td>
                        <td>{itm.typeOfBalance}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default FarmerBalanceList;
